import { Typography, Stack, LinearProgress, Box, Avatar, Badge, Chip } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import Avatars from "./Avatars";
import { useState } from "react";
import { styled } from "@mui/material/styles";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));
export default function ResultBar(props) {
  const { pc, text, showTick, hidePublicVoteCount, data, idx } = props;
  const [open, setOpen] = useState(false);
  const [invisibleDot, setInvisibleDot] = useState(false);
  return (
    <Box>
      <Stack sx={{ position: "relative", height: "36px", mt: 1 }} justifyContent="center">
        <LinearProgress
          variant="determinate"
          value={hidePublicVoteCount ? 0 : pc}
          color="info"
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            borderRadius: "4px",
            backgroundColor: "#eee",
          }}
        />
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ zIndex: 100, position: "absolute", width: "100%", p: 1, cursor: "pointer" }}
          onClick={e => {
            e.preventDefault();
            setOpen(prev => !prev);
            setInvisibleDot(true);
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="subtitle2" component="p">
              {text}
            </Typography>
            {showTick && (
              <Chip
                size="small"
                label={<Typography variant="caption">Your vote</Typography>}
                variant="outlined"
                sx={{ borderRadius: "4px", border: "#000 1px solid" }}
              />
            )}
          </Stack>
          {!hidePublicVoteCount && (
            <Stack direction="row" alignItems="center">
              <Typography variant="subtitle1" component="p" sx={{ mr: 1 }}>
                {pc}%
              </Typography>
              {data && data.length > 0 && (
                <StyledBadge overlap="circular" invisible={idx != 0 || invisibleDot} variant="dot">
                  <Avatars data={data} open={open} />
                </StyledBadge>
              )}
            </Stack>
          )}
        </Stack>
      </Stack>
      {data && data.length > 0 && open && (
        <Box sx={{ mb: 2 }}>
          {data.map((row, idx) => (
            <Stack key={idx} direction="row" sx={{ mt: 1, ml: 1 }}>
              <Avatar src={row.picture} sx={{ display: "inline-block", width: 20, height: 20, mr: 1 }} />
              <Typography variant="caption" color="textSecondary" component="p">
                {row.name} • {row.email}
              </Typography>
            </Stack>
          ))}
        </Box>
      )}
    </Box>
  );
}
